import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDonate } from "../contexts/DonateContext.jsx";
import "../styles/Header.css";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaArrowRight } from "react-icons/fa";

export default function Header({ onDonate, defaultDesignation = "" }) {
  const location = useLocation();
  const { openDonate } = useDonate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    document.body.classList.remove("header-strip-visible");
  }, []);

  const goToDonate = () => {
    if (typeof onDonate === "function") return onDonate();
    if (openDonate) return openDonate({ startOnContact: false, designation: defaultDesignation });
    const el = document.querySelector("#donor-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = "#donor-form";
  };

  return (
    <header className="app-header">
      <Link to="/" className="app-header__brand" aria-label="Gail Thompson Foundation Home">
        <img className="app-header__logo" src="/img/logo.svg" alt="Gail Thompson Foundation" />
      </Link>

      <nav className="app-header__nav" aria-label="Primary">
        <Link to="/" className={location.pathname === "/" ? "active" : ""}>Home</Link>

        <Link to="/donations" className={location.pathname === "/donations" ? "active" : ""}>
          Donations
        </Link>

        <div
          className={`nav-dropdown ${menuOpen ? "open" : ""}`}
          onMouseEnter={() => setMenuOpen(true)}
          onMouseLeave={() => setMenuOpen(false)}
          onFocusCapture={() => setMenuOpen(true)}
          onBlur={(e) => {
            if (!e.currentTarget.contains(e.relatedTarget)) setMenuOpen(false);
          }}
        >
          <button
            type="button"
            className="nav-dropdown__button"
            aria-haspopup="true"
            aria-expanded={menuOpen ? "true" : "false"}
            aria-controls="nav-partnerships-menu"
            onClick={() => setMenuOpen(v => !v)}
          >
            Partnerships <span className="nav-dropdown__chevron" aria-hidden><IoMdArrowDropdown /></span>
          </button>

          <div id="nav-partnerships-menu" className="nav-dropdown__menu" role="menu">
            <Link to="/impact/JAX" role="menuitem" className="nav-dropdown__item">
              <span className="nav-dropdown__item-text">Jackson Laboratory (JAX)</span>
              <FaArrowRight className="nav-dropdown__item-icon" aria-hidden />
            </Link>

            <Link to="/impact/Respite" role="menuitem" className="nav-dropdown__item">
              <span className="nav-dropdown__item-text">Respite Care (“The Club”)</span>
              <FaArrowRight className="nav-dropdown__item-icon" aria-hidden />
            </Link>
          </div>
        </div>
      </nav>

      <div className="app-header__right">
        <button
          className="app-header__button btn-brand-base btn-brand btn-brand--xs"
          onClick={goToDonate}
        >
          Donate Now
        </button>
      </div>
    </header>
  );
}
